import { Routes, Route } from 'react-router-dom';
import { Header, Footer, Login, 
         Companies, Company, PrivacyPolicy,
         Devices, Device, DeviceInfo, Messages, PhoneCalls,
         Users, User, Emails, Error, SetPassword, ForgotPassword,
         DeviceStatuses, DeviceAlarms } from './components/common';
import { AuthProvider } from "./contexts/AuthContext";
import { ServiceProvider } from "./contexts/ServiceContext";
import PrivateRoute from "./services/PrivateRoute";
import { AppAlertContainer } from "./utils/AppAlert";

import './App.css';

function App() {
  
  return (
    <AuthProvider>
      <ServiceProvider>
        <div className="App">
          <AppAlertContainer /> 
          <Header /> 
          <div className="page">
            <Routes>
               <Route path="/login" element={<Login />} />
               <Route path="/" element={<PrivateRoute><Companies/></PrivateRoute>} />
               <Route path="/company/:id" element={<PrivateRoute><Company/></PrivateRoute>} />
               <Route path="/devices" element={<PrivateRoute><Devices/></PrivateRoute>} />
               <Route path="/device/:deviceId" element={<PrivateRoute><Device/></PrivateRoute>} />
               <Route path="/deviceInfo/:deviceId" element={<PrivateRoute><DeviceInfo/></PrivateRoute>} />
               <Route path="/users" element={<PrivateRoute><Users/></PrivateRoute>} />
               <Route path="/user/:userId" element={<User/>} />
               <Route path="/statuses/:deviceId" element={<PrivateRoute><DeviceStatuses/></PrivateRoute>} />
               <Route path="/alarms/:deviceId" element={<PrivateRoute><DeviceAlarms/></PrivateRoute>} />
               <Route path="/emails" element={<PrivateRoute><Emails/></PrivateRoute>} />
               <Route path="/messages" element={<PrivateRoute><Messages/></PrivateRoute>} />
               <Route path="/phoneCalls" element={<PrivateRoute><PhoneCalls/></PrivateRoute>} />
               <Route path="/error" element={<Error/>} />
               <Route path="/set-password" element={<SetPassword/>} />
               <Route path="/forgotPassword" element={<ForgotPassword/>} />
               <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
            </Routes>
          </div>
          <Footer />
        </div>
      </ServiceProvider>
    </AuthProvider>

  );
}

export default App;   
